export const CURRENCY_DISPLAY_MODES = ["both", "czk", "eur"];
export const CURRENCY_DISPLAY_MODE_OPTIONS = [
  { value: "both", label: "CZK + EUR" },
  { value: "czk", label: "Pouze CZK" },
  { value: "eur", label: "Pouze EUR" },
];

export const CURRENCY_DISPLAY_MODE_LABELS = Object.fromEntries(
  CURRENCY_DISPLAY_MODE_OPTIONS.map(({ value, label }) => [value, label])
);

export function normalizeCurrencyDisplayMode(mode) {
  return CURRENCY_DISPLAY_MODES.includes(mode) ? mode : "both";
}

export function getCurrencyVisibility(mode = "both") {
  const normalizedMode = normalizeCurrencyDisplayMode(mode);

  return {
    showCzk: normalizedMode === "both" || normalizedMode === "czk",
    showEur: normalizedMode === "both" || normalizedMode === "eur",
  };
}

export function getStationCurrencyVisibility(station) {
  return getCurrencyVisibility(station?.currency_display_mode);
}

export function stationDisplaysCurrency(station, currency) {
  const { showCzk, showEur } = getStationCurrencyVisibility(station);

  if (currency === "CZK") return showCzk;
  if (currency === "EUR") return showEur;
  return false;
}
